import React, { useState } from "react";
import type { MenuProps } from "antd";
import InnerNav from "components/InnerNav/InnerNav";
import { t } from "i18next";
import Channels from "../Channels/Channels";
import UtmSetting from "../UtmSetting/UtmSetting";

interface EngagementProps {
  currentAppKey: any;
  fetchCurrentAppKeys: any;
}

const Engagement: React.FC<EngagementProps> = ({
  currentAppKey,
  fetchCurrentAppKeys,
}) => {
  const [engagementTab, setEngagementTab] = useState<"channels" | "links">(
    "channels"
  );

  const onTabClick: MenuProps["onClick"] = (e) => {
    setEngagementTab(e.key as "channels" | "links");
  };


  let content = null;

  if (engagementTab === "channels") {
    content = (
      <Channels
        currentAppKey={currentAppKey}
        fetchCurrentAppKeys={fetchCurrentAppKeys}
      />
    );
  } else {
    content = (
      <>
        <div className="engagement-links-nav-container">
          <InnerNav
            theme="light"
            selected="shortener"
            onTabClick={() => {}}
            menu={[{ label: `${t("shortenerLabel")} (UTM)`, key: "shortener" }]}
          />
        </div>
        <UtmSetting
          currentAppKey={currentAppKey}
          updateCurrentAppKey={fetchCurrentAppKeys}
        />
      </>
    );
  }

  return (
    <>
      <div className="engagement-nav-container">
        <InnerNav
          theme="light"
          onTabClick={onTabClick}
          selected={engagementTab}
          menu={[
            { label: t("channelsLabel"), key: "channels" },
            { label: t("linksLabel"), key: "links" },
          ]}
        />
      </div>

      {content}
    </>
  );
};

export default Engagement;